export default {
  split_by_an_amount: "Fractionné par un montant",
  balance_due: "Solde dû",
  want_to_split_by_equal_share: "Vous souhaitez partager à parts égales ?",
};
